import { useNode } from "@craftjs/core";
import React from "react";
import { ScrollToTopSettings } from "./settings";
import SVGIcons from "../../input/icons.json";
import SVG from "react-inlinesvg";
import GrigoraCSSRenderer from "../css-render";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const ScrollToTop = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    icon = "arrow-up-short",
    customIcon,
    hasCustomIcon,
    size = "24px",
    color = "#ffffff",
    backgroundColor = "#16537e",
    layoutPadding = {
      top: "8px",
      bottom: "8px",
      left: "8px",
      right: "8px",
    },
    layoutMargin,
    border,
    borderRadius = {
      bottomLeft: "100px",
      bottomRight: "100px",
      topLeft: "100px",
      topRight: "100px",
    },
    boxShadow,
    position = "fixed",
    topPosition,
    topPositionTablet,
    topPositionMobile,
    bottomPosition = "50px",
    bottomPositionTablet,
    bottomPositionMobile,
    leftPosition,
    leftPositionTablet,
    leftPositionMobile,
    rightPosition = "30px",
    rightPositionTablet,
    rightPositionMobile,
    zindex = 100,
    offset = "400px",
    smoothScrolling = true,
    onlyShowWhenScrollingUp,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-scroll-to-top": true,
      [`scroll-to-top-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__ScrollToTop(id, props)}`}</style>

      {hasCustomIcon && customIcon !== "" ? (
        <SVG className="scroll-to-top__icon" title={icon} src={customIcon} />
      ) : (
        <SVG
          className="scroll-to-top__icon"
          title={icon}
          src={SVGIcons[icon]}
        />
      )}
    </div>
  );
};

// To Avoid Mangling in Production
ScrollToTop.displayName = "ScrollToTop";

ScrollToTop.craft = {
  name: "Scroll To Top",
  props: {},
  related: {
    settings: ScrollToTopSettings,
    supports: [
      "grigora/mouse-movement",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    icon: icon,
    category: "miscellaneous",
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "ScrollToTop",
    slug: "grigora/scroll-to-top",
  },
};
